import React, { Component } from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../../css/Warehouse.css';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import FormAddCar from './FormAddCarPartner';
import FormAddMotorbike from './FormAddMotorbikePartner';
import ListVhcPart from './ListVehiclePartner';

class VehiclePartner extends Component {
  constructor(props) {
    super(props);
    const user = reactLocalStorage.getObject('user.info');

    this.setState({ isPartner: user && user.user_role_id === 3 });
    this.part_id = user ? user.user_part_id : null;
    this.user_vhc_type = user ? user.user_vhc_type : null;
  }

  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}`}
            component={() => (
              <ListVhcPart
                match_parent={this.props.match}
                part_id={this.part_id}
                user_vhc_type={this.user_vhc_type}
              />
            )}
          />
          <Route
            path={`${this.props.match.url}/add-car-partner`}
            component={() => <FormAddCar part_id={this.part_id} />}
          />
          <Route
            path={`${this.props.match.url}/edit-car-vehicle-partner/:vhc_part_id`}
            component={() => <FormAddCar part_id={this.part_id} />}
          />
          <Route
            path={`${this.props.match.url}/edit-moto-vehicle-partner/:vhc_part_id`}
          >
            <FormAddCar part_id={this.part_id} />
          </Route>
          <Route
            path={`${this.props.match.url}/add-motorbike-partner`}
            component={FormAddMotorbike}
          />
        </Switch>
      </div>
    );
  }
}

export default VehiclePartner;
